import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {
    Message,
    TouchApp,
    List,
    Image,
    Videocam,
    HelpOutline,
    CheckCircle,
    LocalOffer,
    Build,
    Person,
    Event,
    AccessTime,
    AssignmentTurnedIn,
    AttachMoney,
    CallSplit,
    Label,
    ShoppingCart,
    LocationOn as LocationOnIcon,
    Receipt as ReceiptIcon,
    Redo as RedoIcon,
    AccountTree as AccountTreeIcon
} from "@material-ui/icons";
import SmartToyIcon from "@material-ui/icons/Android"; // Using Android as ChatGPT icon
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";

const useStyles = makeStyles((theme) => ({
    aside: {
        borderRight: "1px solid #eee",
        padding: "15px 10px",
        fontSize: "12px",
        background: "#fcfcfc",
        width: "260px", // Aumentado um pouco para caber 2 colunas confortavelmente
        height: "100%",
        overflowY: "auto", // Permitir scroll se muitos itens
    },
    description: {
        marginBottom: "15px",
        textAlign: "center",
        color: "#666",
        fontSize: "13px",
    },
    nodesGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr", // 2 Colunas
        gap: "10px",
    },
    dndNode: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "15px 5px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        cursor: "grab",
        color: "#555",
        backgroundColor: "#fff",
        transition: "all 0.2s ease",
        height: "80px", // Altura fixa para uniformidade
        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        "&:hover": {
            backgroundColor: "#f5f5f5",
            borderColor: "#ccc",
            transform: "translateY(-2px)",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        },
        "&:active": {
            cursor: "grabbing",
            transform: "translateY(0)",
        }
    },
    iconWrapper: {
        marginBottom: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    nodeLabel: {
        textAlign: "center",
        fontWeight: 500,
        lineHeight: "1.2",
    }
}));

const nodeTypesList = [
    { type: 'start_order', label: 'Iniciar Pedido', icon: <ShoppingCart />, color: '#4caf50' },
    { type: 'price', label: 'Preço', icon: <AttachMoney />, color: '#ffc107' },
    { type: 'order_address', label: 'Endereço Pedido', icon: <LocationOnIcon />, color: '#03a9f4' },
    { type: 'order_summary', label: 'Resumo Compra', icon: <ReceiptIcon />, color: '#673ab7' },
    { type: 'jump', label: 'Pular', icon: <RedoIcon />, color: '#607d8b' },
    { type: 'products', label: 'Produtos', icon: <ShoppingCart />, color: '#4caf50' },
    { type: 'text', label: 'Mensagem', icon: <Message />, color: '#3498db' },
    { type: 'button', label: 'Botões', icon: <TouchApp />, color: '#9b59b6' },
    { type: 'list', label: 'Lista', icon: <List />, color: '#3f51b5' },
    { type: 'carousel', label: 'Carrossel', icon: <ViewCarouselIcon />, color: '#ff6f00' },
    { type: 'image', label: 'Imagem', icon: <Image />, color: '#e67e22' },
    { type: 'video', label: 'Vídeo', icon: <Videocam />, color: '#e74c3c' },
    { type: 'input', label: 'Pergunta', icon: <HelpOutline />, color: '#2ecc71' },
    { type: 'chatgpt', label: 'ChatGPT', icon: <SmartToyIcon />, color: '#10a37f' },
    { type: 'perplexity', label: 'Perplexity', icon: <SmartToyIcon />, color: '#20808d' },
    { type: 'resolve', label: 'Finalizar', icon: <CheckCircle />, color: '#34495e' },
    { type: 'specialties', label: 'Especialidades', icon: <LocalOffer />, color: '#d81b60' },
    { type: 'services', label: 'Serviços', icon: <Build />, color: '#009688' },
    { type: 'professionals', label: 'Profissionais', icon: <Person />, color: '#03a9f4' },
    { type: 'date_selection', label: 'Data', icon: <Event />, color: '#cddc39' },
    { type: 'hours_selection', label: 'Horários', icon: <AccessTime />, color: '#ffc107' },
    { type: 'confirmation', label: 'Confirmação', icon: <AssignmentTurnedIn />, color: '#4caf50' },
    { type: 'pix_payment', label: 'Pagamento PIX', icon: <AttachMoney />, color: '#ff9800' },
    { type: 'trigger_condition', label: 'Condição', icon: <CallSplit />, color: '#ff5722' },
    { type: 'tag_block', label: 'Adicionar Tag', icon: <Label />, color: '#9c27b0' },
    { type: 'return_to_chatgpt', label: 'Retornar ChatGPT', icon: <KeyboardReturnIcon />, color: '#10a37f' },
    { type: 'return_to_perplexity', label: 'Retornar Perplexity', icon: <KeyboardReturnIcon />, color: '#20808d' },
    { type: 'queue_selection', label: 'Filas', icon: <AccountTreeIcon />, color: '#795548' },
];

export default () => {
    const classes = useStyles();
    console.log("[Chatbot Sidebar] Loaded v1.2 with nodes:", nodeTypesList.map(n => n.type));

    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <aside className={classes.aside}>
            <div className={classes.description}>Arraste os nós</div>
            <div className={classes.nodesGrid}>
                {nodeTypesList.map((node) => (
                    <div
                        key={node.type}
                        className={classes.dndNode}
                        onDragStart={(event) => onDragStart(event, node.type)}
                        draggable
                        style={{ borderBottom: `3px solid ${node.color}` }} // Detalhe colorido inferior
                    >
                        <div className={classes.iconWrapper} style={{ color: node.color }}>
                            {node.icon}
                        </div>
                        <div className={classes.nodeLabel}>
                            {node.label}
                        </div>
                    </div>
                ))}
            </div>
        </aside>
    );
};
